import { render, staticRenderFns } from "./outBound.vue?vue&type=template&id=4f616dcd&scoped=true"
import script from "./outBound.vue?vue&type=script&lang=js"
export * from "./outBound.vue?vue&type=script&lang=js"
import style0 from "./outBound.vue?vue&type=style&index=0&id=4f616dcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f616dcd",
  null
  
)

export default component.exports